import React, {
    useState,
    useEffect,
    useRef,
    useLayoutEffect,
    useCallback,
  } from "react";
  import { useParams } from "react-router-dom";
  import {
    clearInterval,
    clearTimeout,
    setInterval,
    setTimeout,
  } from "worker-timers";
  function TimerDisplay(props) {
    
  const intervalRef1 = useRef(null);
  const [viewDocTime, setViewDocTime] = useState(0);

  const convertToHHMMSS = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const remainingSeconds = totalSeconds % 60;

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

    useEffect(() => {
      if (intervalRef1.current) {
        clearInterval(intervalRef1.current);
        intervalRef1.current = null;
      }
      intervalRef1.current = setInterval(function () {
        setViewDocTime((prevViewDocTime) => prevViewDocTime + 1);
      }, 1000);
      return () => {
        clearInterval(intervalRef1.current);
        intervalRef1.current = null;
      };
    }, []);
    useEffect(() => {
      window.addEventListener("offline", () => {
        if (intervalRef1.current) {
          clearInterval(intervalRef1.current);
          intervalRef1.current = null;
        }
      });
  
      window.addEventListener("online", () => {
        if (intervalRef1.current) {
          clearInterval(intervalRef1.current);
          intervalRef1.current = null;
        }
        intervalRef1.current = setInterval(function () {
          setViewDocTime((prevViewDocTime) => prevViewDocTime + 1);
        }, 1000);
      });
    }, []);
    return(<li>
      <p
        className={props.class}
        style={props.style}
      >
        {props.reader_viewTime}
        {" (hh:mm:ss)"}: {convertToHHMMSS(viewDocTime)}
        {/* {viewDocTime === 1 ? "Min" : "Mins"} */}
      </p>
    </li>
    );
  }
  export default TimerDisplay;